






















import Vue, { PropType } from 'vue'

import * as vClickOutside from 'v-click-outside'

export type PopupMenuItem = {
  id: number
  title: string
  iconName?: string
  isDestructive?: boolean
  link?: string
}

export enum PopupMenuExpandDirection {
  left = 1,
  up,
  right,
  down
}

export default Vue.extend({
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    expandDirection: {
      type: Number as PropType<PopupMenuExpandDirection>,
      default: PopupMenuExpandDirection.left
    },
    items: {
      type: Array as PropType<PopupMenuItem[]>,
      required: true
    }
  },
  data() {
    return {
      isCollapsed: true,
      eventListener: null
    }
  },
  computed: {
    cssClass(): { [key: string]: boolean } {
      return {
        'popup-menu--collapsed': this.isCollapsed === true,
        'popup-menu--expand-left': this.expandDirection === PopupMenuExpandDirection.left,
        'popup-menu--expand-up': this.expandDirection === PopupMenuExpandDirection.up,
        'popup-menu--expand-right': this.expandDirection === PopupMenuExpandDirection.right,
        'popup-menu--expand-down': this.expandDirection === PopupMenuExpandDirection.down
      }
    }
  },
  methods: {
    closeMenu() {
      this.isCollapsed = true
    },
    toggleOpenState() {
      this.isCollapsed = !this.isCollapsed
    },
    selectItem(id: number) {
      this.isCollapsed = true
      this.$emit('selectItem', id)
    }
  }
})
